import React, { FunctionComponent, ReactNode } from 'react';
import * as Styled from './styled';
import { PlatformUrl } from 'ui/types/urls';
import Translate from 'ui/atoms/translate';
import Spacer from 'ui/atoms/spacer';
import config from 'core/config/local';
import DemoStickyMessage from 'ui/molecules/demo-sticky-message';

export interface PublicationsLayoutProps {
  children: ReactNode;
}

const PublicationsLayout: FunctionComponent<PublicationsLayoutProps> = ({ children }) => {
  return (
    <Styled.Container>
      {config.production || <DemoStickyMessage />}
      <Styled.Main>{children}</Styled.Main>
      <Styled.Footer>
        <Styled.FooterWideContent>
          <Styled.LinkContainer>
            <Styled.FooterLink platformUrl={PlatformUrl.IMPRINT}>
              <Translate name="publications.footer.imprint" />
            </Styled.FooterLink>
            <Spacer x={4} />
            <Styled.FooterLink platformUrl={PlatformUrl.PRIVACY_POLICY}>
              <Translate name="publications.footer.privacy" />
            </Styled.FooterLink>
          </Styled.LinkContainer>
        </Styled.FooterWideContent>
      </Styled.Footer>
    </Styled.Container>
  );
};

export default PublicationsLayout;
